<template>
  <!-- <div> -->
  <div
    ref="all_DC_info_small"
    :style="{
      height: '100%',
      width: '100%',
      backgroundImage: 'url(' + this.backgroud_png + ') ',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      opacity: 0.8,
    }"
  ></div>
  <!-- </div> -->
</template>

  <script>
import * as echarts from "echarts";
import { Url, grafana_Url, tooltip_basecss } from "../config/env";
export default {
  data() {
    return {
      mychartOptions: {},
      baseUrl: Url,
      backgroud_png: Url + "/topo_data/all_DC_info_small/all_dc_bg.png",
      chartWidth: 1270,
      chartHeight: 534,
      envData: {
        colors: {
          status_colors: ["#004495", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
        },
      },
    };
  },
  components: {},
  methods: {
    getTopoData: async function (topo_name, env_Data) {
      let options = {};
      //获取全局变量
      const status_colors = env_Data.colors.status_colors;
      var border_colors = env_Data.colors.border_colors;
      // 获取图中主机数据
      const hosts_file = Url + "topo_data/" + topo_name + "/hosts_obj.json";
      const lines_file = Url + "topo_data/" + topo_name + "/lines_obj.json";
      const [hosts_data, lines_data] = await Promise.all([
        fetch(hosts_file),
        fetch(lines_file),
      ]);
      const hostsData = await hosts_data.json();
      const linesData = await lines_data.json();
      const hosts = hostsData["data"];
      const lines = linesData["data"];
      let charts = {
        hosts: [],
        lines: [],
      };
      //  生成节点数据
      for (let key in hosts) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        // let problem_info = "系统正常"
        // let tooltip_obj = hosts[key]["item_info"];
        let tooltip_list = hosts[key]["item_info"];
        let problem_obj = hosts[key]["problems"];

        if (Object.keys(tooltip_list).length != 0) {
          tooltip_info = "";
          for (let item of tooltip_list) {
            tooltip_info +=
              '<div><span style="color:gray">' +
              Object.keys(item) +
              '</span>:<span style="color:green">' +
              Object.values(item) +
              "</></div>";
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                problem_obj[i]["hostname"] +
                " : " +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' +
                n +
                "." +
                problem_obj[i]["hostname"] +
                " : " +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:green">系统正常</div>';
        }
        let node = {
          // x: hosts[key]["coords"][0],
          // y: hosts[key]["coords"][1],
          name: hosts[key]["nodeName"],
          value: hosts[key]["coords"],
          symbolSize: hosts[key]["symbolSize"],
          // symbolSize: hosts[key]["symbolSize"].split(","),
          nodeStatus: hosts[key]["nodeStatus"],
          symbol:
            "image://" +
            Url +
            "/topo_data/" +
            topo_name +
            "/" +
            hosts[key]["pngPath"] +
            ".png",
          itemStyle: {
            color: status_colors[hosts[key]["nodeStatus"]],
          },
          // label: {
          //     show: hosts[key]["labelShow"] == true,
          //     position: "bottom",
          //     color: "#4301E6",
          //     fontFamily: "Arial",
          //     fontSize: 15,
          //     formatter: hosts[key]["nodeName"]
          // },
          tooltip: tooltip_info,
          url1:
            hosts[key]["url1"][0] == "#"
              ? Url + hosts[key]["url1"]
              : grafana_Url[hosts[key]["url1"]] +
                "&var-HOST=" +
                hosts[key]["zabbix_hostname"],
          url2:
            hosts[key]["url2"][0] == "#"
              ? Url + hosts[key]["url2"]
              : hosts[key]["url2"],
        };
        charts.hosts.push(node);
      }
      // 生成连线数据
      for (let key in lines) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        // let problem_info = "系统正常"
        let tooltip_obj = lines[key]["item_info"];
        let problem_obj = lines[key]["problems"];
        if (Object.keys(tooltip_obj).length != 0) {
          tooltip_info = "";
          for (let i in tooltip_obj) {
            tooltip_info +=
              '<div style="color:gray">' + i + ": " + tooltip_obj[i] + "</div>";
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                problem_obj[i] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' + n + "." + problem_obj[i] + "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:green">系统正常</div>';
        }
        let line = {
          lineName: lines[key]["lineName"],
          coords: lines[key]["coords"],
          lineStatus: lines[key]["lineStatus"],
          // effectShow: lines[key]["effectShow"],
          lineStyle: {
            width:
              lines[key]["lineWidth"].length > 0
                ? lines[key]["lineWidth"]
                : null,
            opacity:
              lines[key]["lineOpacity"].length > 0
                ? lines[key]["lineOpacity"]
                : null,
            curveness:
              lines[key]["lineCurveness"].length > 0
                ? lines[key]["lineCurveness"]
                : null,
            color:
              lines[key]["lineColor"].length > 0
                ? lines[key]["lineColor"]
                : null,
            // type: "solid",
          },
          tooltip: tooltip_info,
          url1:
            lines[key]["url1"].length > 0
              ? grafana_Url[lines[key]["url1"]] +
                "&var-Brand=" +
                lines[key]["lineName"]
              : grafana_Url["item_url"] + lines[key]["items"],
          click_redirect: "true",
        };
        charts.lines.push(line);
      }
      return charts;
    },
    makeChartOption(chartData) {
      let options = {
        // backgroundColor: "#111217",
        // backgroundColor: "#eee",
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
        xAxis: {
          min: 0,
          max: this.chartWidth,
          show: false,
          type: "value",
        },
        yAxis: {
          min: 0,
          max: this.chartHeight,
          show: false,
          inverse: true,
          type: "value",
        },
        tooltip: tooltip_basecss,
        series: [
          {
            type: "graph",
            coordinateSystem: "cartesian2d",
            // roam: true,
            layout: "none",
            emphasis: {
              // disabled: true,
              // scale: 1.5,
              // focus: 'self',
              // blurScope: 'global'
            },
            label: {
              // show: true,
              position: "insideTopLeft",
              offset: [-20, -20],
              color: "white",
              fontSize: 20,
              formatter: function (item) {
                return item.data.name;
              },
            },

            data: chartData.hosts,
            zlevel: 5,
          },
          {
            type: "lines",
            show: false,
            polyline: true,
            coordinateSystem: "cartesian2d",
            emphasis: {
              lineStyle: {
                type: "solid",
                color: "gray",
                width: 4,
                // curveness: 0.6,
              },
            },
            lineStyle: {
              color: "#f46827",
              show: true,
              width: 1.5,
              type: "solid",
              shadowBlur: 3, // 折线模糊
              // shadowOffsetX: 0, // 折线的X偏移
              // shadowOffsetY: 10, // 折线的Y偏移
              // shadowColor: "rgba(255.255.255, 0.8)", //设置折线阴影颜色

              // opacity: 0.1,
              // curveness: 0.3,
            },
            effect: {
              show: true,
              // loop: true,
              roundTrip: true,
              period: 3, // 图标飞跃速度，值越小速度越快
              trailLength: 2, // 尾迹长度[0,1]值越大，尾迹越长
              symbol: "arrow", // 图标类型
              symbolSize: 9, // 图标大小
              color: "yellow", // 图标颜色
            },
            data: chartData.lines,
            zlevel: 2,
          },
        ],
      };
      return options;
    },
    maketopo: async function (topo_name) {
      let myChart = echarts.init(this.$refs[topo_name]);
      let myChartData = await this.getTopoData(topo_name, this.envData);
      this.mychartOptions = this.makeChartOption(myChartData);
      myChart.setOption(this.mychartOptions);
      //故障节点动画效果
      setInterval(() => {
        for (let i in this.mychartOptions.series[0].data) {
          if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
            this.mychartOptions.series[0].data[i]["symbolSize"] *= 1.2;
          }
        }
        myChart.setOption(this.mychartOptions);

        setTimeout(() => {
          for (let i in this.mychartOptions.series[0].data) {
            if (
              // this.mychartOptions.series[0].data[i]["itemStyle"]["color"] !=
              // this.envData.colors.status_colors[0]
              this.mychartOptions.series[0].data[i]["nodeStatus"] != 0
            ) {
              this.mychartOptions.series[0].data[i]["symbolSize"] /= 1.2;
            }
          }
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);
      // 故障线条动画效果
      setInterval(() => {
        for (let i in this.mychartOptions.series[1].data) {
          if (
            this.mychartOptions.series[1].data[i]["lineStatus"] != 0
            // this.mychartOptions.series[1].data[i]["lineStyle"]["color"] !=
            // this.envData.colors.status_colors[0]
          ) {
            this.mychartOptions.series[1].data[i]["lineStyle"]["type"] =
              "solid";
            // this.mychartOptions.series[1].data[i]["lineStyle"]["color"] = "red";
            this.mychartOptions.series[1].data[i]["zlevel"] = 4;
          }
        }
        myChart.setOption(this.mychartOptions);

        setTimeout(() => {
          for (let i in this.mychartOptions.series[1].data) {
            if (
              this.mychartOptions.series[1].data[i]["lineStatus"] != 0
              // this.mychartOptions.series[1].data[i]["lineStyle"]["color"] !=
              // this.envData.colors.status_colors[0]
            ) {
              this.mychartOptions.series[1].data[i]["lineStyle"]["type"] =
                "dashed";
              // this.mychartOptions.series[1].data[i]["lineStyle"]["color"] =
              //   "#09B034";
              this.mychartOptions.series[1].data[i]["zlevel"] = 3;
            }
          }
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);
      let click_type = null; // 定义一个定时器
      myChart.on("click", (data) => {
        if (!click_type) {
          click_type = setTimeout(() => {
            window.location.assign(data.data.url1);
            click_type = null; // 清除定时器
          }, 300);
        } else {
          window.open(data.data.url2);
          clearTimeout(click_type); // 清除定时器
          click_type = null;
        }
      });
      setInterval(async () => {
        // myChart.setOption(this.getTopoData("all_DC_info_small", this.envData));
        this.mychartOptions = this.makeChartOption(
          await this.getTopoData("all_DC_info_small", this.envData)
        );
        // myChart.setOption(this.mychartOptions);
      }, 60000);
      window.onresize = function () {
        myChart.resize();
        this.chartWidth = myChart.getDom().clientWidth;
        this.chartHeight = myChart.getDom().clientHeight;
      };
    },
  },
  mounted() {
    this.maketopo("all_DC_info_small");
  },
};
</script>
  <style lang="less" scoped>
@import "../style/mixin";
</style>
  
